var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"course-card",on:{"click":function($event){return _vm.handleRoute('/view-course/'+_vm.id)}}},[_c('img',{staticClass:"course-image",attrs:{"src":_vm.image,"alt":"Course Image"}}),_c('div',{staticClass:"course-content"},[_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('button',{staticClass:"view-btn"},[_vm._v("View Course")])])
}
var staticRenderFns = []

export { render, staticRenderFns }